import { LoggedPerson } from './pessoa-nome';

/** Prefixo aplicado à foto crua (base64 sem prefixo) retornada pelo endpoint de pessoa logada. */
export const PHOTO_PREFIX = 'data:image/jpeg;base64,';

/** Prefixa a foto crua do endpoint com o prefixo de data URI. */
export function prefixPhoto(foto: string): string {
  return PHOTO_PREFIX + foto;
}

/**
 * Precedência de exibição: cache não-vazio → cache; senão `pessoa.foto` (prefixada) quando
 * presente e não-vazia; senão `null`. Espelha `validarFotoStorage` + `carregarPessoaLogada`.
 */
export function resolveDisplayPhoto(
  cache: string | null,
  person: LoggedPerson | null,
): string | null {
  if (cache) {
    return cache;
  }

  if (person?.foto) {
    return prefixPhoto(person.foto);
  }

  return null;
}

/** Valor a persistir em `foto_pessoa` após carregar a pessoa: prefixada quando há foto, senão `null`. */
export function photoForCache(person: LoggedPerson | null): string | null {
  if (person?.foto) {
    return prefixPhoto(person.foto);
  }

  return null;
}
